module.exports = __webpack_public_path__ + "img/17.6d4a282b.jpg";